module.exports = __webpack_public_path__ + "img/centara-grand-hotel-osaka.3c3d9072.svg";